import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { SubscriptionService } from 'src/app/services/subscriptions/subscription.service';

@Component({
  selector: 'app-request-subscription-modal',
  standalone: false,
  templateUrl: './request-subscription-modal.component.html',
  styleUrl: './request-subscription-modal.component.scss'
})
export class RequestSubscriptionModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() onCancel = new EventEmitter();
  @Output() onSend = new EventEmitter();

  @Input() providerTenantId!: string;

  isSubmitting: boolean = false;

  constructor(
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private subscriptionService: SubscriptionService
  ) {

  }

  send() {
    this.isSubmitting = true;

    this.loadingService.load(
      this.subscriptionService.requestSubscription(this.providerTenantId)
    ).subscribe(() => {
      this.isSubmitting = false;
      this.toastrService.success(
        this.translateService.instant('SUBSCRIPTIONS.REQUESTED-SUBSCRIPTION-SUCCESSFULLY')
      );

      this.onSend.emit();
      this.close();
    });
  }

  cancel() {
    this.onCancel.emit();
    this.close();
  }

  private close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
